import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'

// Quantity stepper (DESIGN.md §Components, "Quantity stepper (Steps 7, 8, 9)") — a
// −/+ numeric control with an optional per-instance ceiling. First real consumer:
// story e8-6's AdditionalServicesStepComponent; e8-7 (Steps 8/9 pack counts) reuses
// this unmodified. No required/errorText/invalid-state inputs — every quantity field
// in this epic so far is optional (YAGNI, matches FamilyGoalsStepComponent's lean shape).
@Component({
  selector: 'app-quantity-stepper',
  templateUrl: './quantity-stepper.component.html',
  styleUrls: ['./quantity-stepper.component.scss'],
  standalone: false,
})
export class QuantityStepperComponent implements OnInit {
  @Input() control: FormControl<number>
  @Input() label: string
  @Input() max?: number

  id: string

  ngOnInit(): void {
    this.id = LabelToId(this.label)
  }

  decrement(): void {
    this.control.setValue(Math.max(0, this.control.value - 1))
    this.control.markAsTouched()
  }

  increment(): void {
    this.control.setValue(
      this.max !== undefined
        ? Math.min(this.max, this.control.value + 1)
        : this.control.value + 1,
    )
    this.control.markAsTouched()
  }
}
